import { error } from 'react-notification-system-redux';
import { call, put, takeLatest } from 'redux-saga/effects';

import { notificationsConfig } from '../../../config/constants';
import api from '../../../core/api';
import { commonActions } from '../../actions';

export function* rolesFetchSaga() {
  try {
    const result = yield call(api.common.getRoles);

    yield put(
      commonActions.getRolesList.done({
        params: {},
        result,
      }),
    );
  } catch {
    yield put(
      error({
        translationKey: 'widget:cant_roles',
        ...notificationsConfig.defaultConf,
      }),
    );
  }
}

export function* watchCommonSaga() {
  yield [yield takeLatest(commonActions.getRolesList.started, rolesFetchSaga)];
}
